import { Typography } from '@mui/material';
import { jsTypeHelper } from '@tap/utils';

export const AnyValue = ({ value }: { value: any }) => {
    return (
        <Typography>{jsTypeHelper.isString(value) ? value.toString() : JSON.stringify(value)}</Typography>
    );
}